import { useEffect, useState } from 'react';

/**
 * Whether this tab is the one being looked at.
 *
 * For screens that poll. A tab left open behind others should stop asking
 * rather than keep a query running all week for nobody, and picks up again the
 * moment it is brought back to the front.
 */
export function useDocumentVisible(): boolean {
  const [visible, setVisible] = useState(() => !document.hidden);

  useEffect(() => {
    const onChange = () => setVisible(!document.hidden);
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);

  return visible;
}
